import Grid from "@mui/material/Grid";

import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpTypographyField,
  CmpInputField,
  CmpSelectField,
  CmpCheckboxField,
  CmpDatePickerField,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";
import GCSupplierSearch from "../../../Component/Common/ReuseableComponent/GCSupplierSearch.jsx";
import GCBrandSearch from "../../../Component/Common/ReuseableComponent/GCBrandSearch.jsx";

export default function WmsHead({
  fLocation_MultiSelect,
  sLocationData,

  fMainGroup_MultiSelect,
  sMainGroupData,
  fSubGroup_MultiSelect,
  sSubGroupData,

  fGroup_MultiSelect,
  sGroupData,

  fBrand_MultiSelect,
  sBrandData,

  fBrandGroup_MultiSelect,
  sBrandGroupData,

  fVendor_MultiSelect,
  sVendorData,
  fCustomer_MultiSelect,
  sCustomerData,

  //multiselect
  sWebWMSSalesReportData,
  sWebBetweenReportArr,
  sWebTransTypeReportArr,
  sCountryData,
  fCountry_MultiSelect,

  sSeasonData,
  fSeason_MultiSelect,

  sSalesManData,
  fSalesMan_MultiSelect,
  fSalesMan,

  sDocTypeData,
  fDocType_MultiSelect,

  HeadObject,
  setHeadObject,
  fLocation,
  fMainGroup,
  fSubGroup,
  fGroup,
  fVendor,
  fCustomer,
  fBrand,
  fItem,
  fCountry,
  fSeason,
  fDocType,

  fFromDate,
  fToDate,
  fDate,
  //item name
  fItemName_onKeyUp,
  fItemName,
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,

  fProperty1,
  fProperty1_MultiSelect,

  fProperty2,
  fProperty2_MultiSelect,

  fProperty3,
  fProperty3_MultiSelect,

  fProperty4,
  fProperty4_MultiSelect,

  fAnalysis1,
  fAnalysis1_MultiSelect,

  fAnalysis2,
  fAnalysis2_MultiSelect,

  fAnalysis3,
  fAnalysis3_MultiSelect,

  fAnalysis4,
  fAnalysis4_MultiSelect,
  fAnalysis5,
  fAnalysis5_MultiSelect,
  fAnalysis6,
  fAnalysis6_MultiSelect,
  fAnalysis7,
  fAnalysis7_MultiSelect,

  fTransType,

  sProperty1Data,
  sProperty2Data,
  sProperty3Data,
  sProperty4Data,
  sAnalysis1Data,
  sAnalysis2Data,
  sAnalysis3Data,
  sAnalysis4Data,
  sAnalysis5Data,
  sAnalysis6Data,
  sAnalysis7Data,
  //CheckBox Start
  sWMSSalesReportCheckBoxModal,
  fOpenWMSSalesReportCheckBoxModal,
  fCloseWMSSalesReportCheckBoxModal,
  sIsChecked,
  WMSSalesReportCheckbox,
  fSetCheckBox,
  fIsAllChecked,
  //CheckBox End
}) {
  return (
    <form id="WMSSalesReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center "
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"MIS Sales Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
          <MoreVertIcon onClick={fOpenWMSSalesReportCheckBoxModal} />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Date"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDate"
                xValue={HeadObject.sDate}
                xOnChange={fDate}
                xName={"sDate"}
                xData={sWebBetweenReportArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sFromDate}
                xOnChange={fFromDate}
                xName={"sFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sToDate}
                xOnChange={fToDate}
                xName={"sToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"03"}
                xLabelText="sMainGroup"
                xValue={HeadObject.sMainGroup}
                xOnChange={fMainGroup}
                xName={"sMainGroup"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"04"}
                options={sMainGroupData}
                xDisabled={
                  HeadObject?.sMainGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sMainGroupArr}
                setValue={fMainGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"05"}
                xLabelText="sSubGroup"
                xValue={HeadObject.sSubGroup}
                xOnChange={fSubGroup}
                xName={"sSubGroup"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"06"}
                options={sSubGroupData}
                xDisabled={
                  HeadObject?.sSubGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sSubGroupArr}
                setValue={fSubGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"07"}
                xLabelText="sGroup"
                xValue={HeadObject.sGroup}
                xOnChange={fGroup}
                xName={"sGroup"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"08"}
                options={sGroupData}
                xDisabled={
                  HeadObject?.sGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sGroupArr}
                setValue={fGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Item"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"14"}
                xLabelText="sItem"
                xValue={HeadObject.sItem}
                xOnChange={fItem}
                xName={"sItem"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <CmpInputField
                xValue={HeadObject.sItemCode}
                xType={"text"} // text/number/password
                xName={"sItemCode"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <GCToggleSearch
                xtabIndex={"15"}
                xName={"sItemName"}
                xType={"text"}
                xValue={HeadObject?.sItemName}
                xReadOnly={
                  HeadObject?.sItem?.toUpperCase() === "ALL" ? true : false
                }
                xOnChange={fItemName}
                xOnKeyUp={fItemName_onKeyUp}
                xError={false}
                xErrorMessage={""}
                xMediaQuery={xMediaQuery}
                xonClickbtn={xonClickbtn}
                xrows={xrows}
                xcolumns={xcolumns} //head
                xRowCellClick={xRowCellClick}
                xRowClick={xRowClick}
                xToggle={xToggle}
                xData={xData}
                xOnChangeDropdownInput={xOnChangeDropdownInput}
                xDropdownObj={xDropdownObj}
                xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"11"}
                xLabelText="sBrand"
                xValue={HeadObject.sBrand}
                xOnChange={fBrand}
                xName={"sBrand"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            {/* <Grid item xs={6} sm={6} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"12"}
                options={sBrandData}
                xDisabled={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sBrandArr}
                setValue={fBrand_MultiSelect}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"13"}
                options={sBrandGroupData}
                xDisabled={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sBrandGroupArr}
                setValue={fBrandGroup_MultiSelect}
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCBrandSearch
                xValue={HeadObject?.sBrandSearchValue} //main input value
                xOnChange={(e) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={HeadObject?.sBrandArr} //Search basket array
                xListValue={HeadObject?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Vendor"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sVendor"
                xValue={HeadObject.sVendor}
                xOnChange={fVendor}
                xName={"sVendor"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              {/* <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sVendorData}
                xDisabled={
                  HeadObject?.sVendor?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sVendorArr}
                setValue={fVendor_MultiSelect}
              /> */}
              <GCSupplierSearch
                xValue={HeadObject.sVendorSearchValue} //main input value
                xOnChange={(e) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sVendorSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  HeadObject?.sVendor?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={HeadObject?.sVendorArr} //Search basket array
                xListValue={HeadObject?.sVendorArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sVendorArr: selectedObjects,
                  }));
                  console.log('selectedObjects',selectedObjects);
                  
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Country"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"18"}
                xLabelText="sCountry"
                xValue={HeadObject.sCountry}
                xOnChange={fCountry}
                xName={"sCountry"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={HeadObject?.sLocationArr <= 0 ? true : false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sCountryData}
                xDisabled={
                  HeadObject?.sCountry?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sCountryArr}
                setValue={fCountry_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Season"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sSeason"
                xValue={HeadObject.sSeason}
                xOnChange={fSeason}
                xName={"sSeason"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sSeasonData}
                xDisabled={
                  HeadObject?.sSeason?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sSeasonArr}
                setValue={fSeason_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"SalesMan"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sSalesMan"
                xValue={HeadObject.sSalesMan}
                xOnChange={fSalesMan}
                xName={"sSalesMan"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sSalesManData}
                xDisabled={
                  HeadObject?.sSalesMan?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sSalesManArr}
                setValue={fSalesMan_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Doc.Type"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"22"}
                xLabelText="sDocType"
                xValue={HeadObject.sDocType}
                xOnChange={fDocType}
                xName={"sDocType"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sDocTypeData}
                xDisabled={
                  HeadObject?.sDocType?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sDocTypeArr}
                setValue={fDocType_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Customer"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sCustomer"
                xValue={HeadObject.sCustomer}
                xOnChange={fCustomer}
                xName={"sCustomer"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sCustomerData}
                xDisabled={
                  HeadObject?.sCustomer?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sCustomerArr}
                setValue={fCustomer_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* WMSSalesReportCheckbox */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis1Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis1"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis1"
                xValue={HeadObject.sAnalysis1}
                xOnChange={fAnalysis1}
                xName={"sAnalysis1"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis1Data}
                xDisabled={
                  HeadObject?.sAnalysis1?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis1Arr}
                setValue={fAnalysis1_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis2Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis2"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis2"
                xValue={HeadObject.sAnalysis2}
                xOnChange={fAnalysis2}
                xName={"sAnalysis2"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis2Data}
                xDisabled={
                  HeadObject?.sAnalysis2?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis2Arr}
                setValue={fAnalysis2_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis3Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis3"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis3"
                xValue={HeadObject.sAnalysis3}
                xOnChange={fAnalysis3}
                xName={"sAnalysis3"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis3Data}
                xDisabled={
                  HeadObject?.sAnalysis3?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis3Arr}
                setValue={fAnalysis3_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis4Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis4"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis4"
                xValue={HeadObject.sAnalysis4}
                xOnChange={fAnalysis4}
                xName={"sAnalysis4"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis4Data}
                xDisabled={
                  HeadObject?.sAnalysis4?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis4Arr}
                setValue={fAnalysis4_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis5Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis5"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis5"
                xValue={HeadObject.sAnalysis5}
                xOnChange={fAnalysis5}
                xName={"sAnalysis5"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis5Data}
                xDisabled={
                  HeadObject?.sAnalysis5?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis5Arr}
                setValue={fAnalysis5_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis6Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis6"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis6"
                xValue={HeadObject.sAnalysis6}
                xOnChange={fAnalysis6}
                xName={"sAnalysis6"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis6Data}
                xDisabled={
                  HeadObject?.sAnalysis6?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis6Arr}
                setValue={fAnalysis6_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sAnalysis7Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Analysis7"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sAnalysis7"
                xValue={HeadObject.sAnalysis7}
                xOnChange={fAnalysis7}
                xName={"sAnalysis7"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sAnalysis7Data}
                xDisabled={
                  HeadObject?.sAnalysis7?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sAnalysis7Arr}
                setValue={fAnalysis7_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sProperty1Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Property1"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sProperty1"
                xValue={HeadObject.sProperty1}
                xOnChange={fProperty1}
                xName={"sProperty1"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sProperty1Data}
                xDisabled={
                  HeadObject?.sProperty1?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sProperty1Arr}
                setValue={fProperty1_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sProperty2Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Property2"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sProperty2"
                xValue={HeadObject.sProperty2}
                xOnChange={fProperty2}
                xName={"sProperty2"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sProperty2Data}
                xDisabled={
                  HeadObject?.sProperty2?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sProperty2Arr}
                setValue={fProperty2_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sProperty3Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Property3"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sProperty3"
                xValue={HeadObject.sProperty3}
                xOnChange={fProperty3}
                xName={"sProperty3"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sProperty3Data}
                xDisabled={
                  HeadObject?.sProperty3?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sProperty3Arr}
                setValue={fProperty3_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sProperty4Data ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Property4"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sProperty4"
                xValue={HeadObject.sProperty4}
                xOnChange={fProperty4}
                xName={"sProperty4"}
                xData={sWebWMSSalesReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sProperty4Data}
                xDisabled={
                  HeadObject?.sProperty4?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sProperty4Arr}
                setValue={fProperty4_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={
            WMSSalesReportCheckbox.sTransTypeData ? "" : "hide-content"
          }
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"TransType"} />
            </Grid>
            <Grid item xs={3} sm={3} md={3} lg={3}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sTransType"
                xValue={HeadObject.sTransType}
                xOnChange={fTransType}
                xName={"sTransType"}
                xData={sWebTransTypeReportArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        open={sWMSSalesReportCheckBoxModal}
        onClose={fCloseWMSSalesReportCheckBoxModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-WMSSalesReport-CheckBox">
          <GCTitleSticky
            title={"Check List"}
            onClose={fCloseWMSSalesReportCheckBoxModal}
          />

          <Grid
            container
            spacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="py-3 px-2"
          >
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={sIsChecked}
                xOnChange={(e) => {
                  fIsAllChecked(e);
                }}
                xDisabled={false}
                xName={"All"}
                xNameField={"All"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sProperty1Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sProperty1Data"}
                xNameField={"Property1"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sProperty2Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sProperty2Data"}
                xNameField={"Property2"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sProperty3Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sProperty3Data"}
                xNameField={"Property3"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sProperty4Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sProperty4Data"}
                xNameField={"Property4"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis1Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis1Data"}
                xNameField={"Analysis1"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis2Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis2Data"}
                xNameField={"Analysis2"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis3Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis3Data"}
                xNameField={"Analysis3"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis4Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis4Data"}
                xNameField={"Analysis4"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis5Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis5Data"}
                xNameField={"Analysis5"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis6Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis6Data"}
                xNameField={"Analysis6"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sAnalysis7Data}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sAnalysis7Data"}
                xNameField={"Analysis7"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpCheckboxField
                xChecked={WMSSalesReportCheckbox.sTransTypeData}
                xOnChange={(e) => {
                  fSetCheckBox(e);
                }}
                xDisabled={false}
                xName={"sTransTypeData"}
                xNameField={"TransType"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </form>
  );
}
